import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/Container';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { t } from '../../../i18n';
import UrlTo from '../../../url-to';
import BreadCrumbs from '../../components/breadcrumbs';
import { getGiftCardCheckoutState } from '../../selectors';
import StripeProvider from '../checkout/components/stripe-provider';
import PaymentScreen from '../checkout/subscreens/payment-screen';
import StripePaymentResultScreen from '../checkout/subscreens/stripe-payment-result-screen';
import SwishPaymentResultScreen from '../checkout/subscreens/swish-payment-result-screen';
import CheckoutContext from '../checkout/checkout-context';
import GiftCardPreviewDesktop from './components/gift-card-preview-desktop';
import GiftCardPreviewMobile from './components/gift-card-preview-mobile';
import './styles.scss';

const GiftCardCheckout = () => {
  const breadCrumbItems = [
    {
      url: UrlTo.coursesHome(),
      name: t('DIGITAL_COURSES.HOME_SCREEN.NAME'),
    },
    {
      isActive: true,
      name: t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.BUY_GIFT_CARD'),
    },
  ];

  const [swish, setSwish] = useState(true);
  const { data, hasError } = useSelector(getGiftCardCheckoutState);

  if (hasError) {
    return <Alert variant="danger">{t('SERVER_ERROR')}</Alert>;
  }

  return (
    <CheckoutContext.Provider value={{ swish, setSwish }}>
      <Container className="courses-gift-card-checkout">
        <BreadCrumbs navigationLinks={breadCrumbItems} />
        <h1>{t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.BUY_GIFT_CARD')}</h1>
        <GiftCardPreviewDesktop price={data?.price} coursesStats={data?.coursesStats} />
        <GiftCardPreviewMobile price={data?.price} />
        <StripeProvider>
          <Switch>
            <Route exact path={UrlTo.coursesGiftCardCheckout()} component={PaymentScreen} />
            <Route exact path={UrlTo.coursesGiftCardStripeCheckoutResult({})} component={StripePaymentResultScreen} />
            <Route exact path={UrlTo.coursesGiftCardSwishCheckoutResult({})} component={SwishPaymentResultScreen} />
          </Switch>
        </StripeProvider>
      </Container>
    </CheckoutContext.Provider>
  );
};

export default GiftCardCheckout;
